export default __webpack_public_path__ + "static/media/flower_5000.8228014b.jpg";